import React, { useRef, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';
import PopperJs from 'popper.js';

import { formatMoney } from '../../lib/utils';

import './style.css';

interface Props {
  children: React.ReactElement;
  value: number;
}

export function ValueLabelComponent(props: Props) {
  const { children, value } = props;

  const popperRef = useRef<PopperJs | null>(null);
  useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });

  return (
    <Tooltip
      PopperProps={{ popperRef }}
      open
      enterTouchDelay={0}
      placement="top"
      interactive
      title={`$${formatMoney(String(value), 2)}`}
    >
      {children}
    </Tooltip>
  );
}

export function ValueLabelPlazoComponent(props: Props) {
  const { children, value } = props;

  const popperRef = useRef<PopperJs | null>(null);
  useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });

  return (
    <Tooltip
      PopperProps={{ popperRef }}
      open
      enterTouchDelay={0}
      placement="top"
      title={`${value} días`}
    >
      {children}
    </Tooltip>
  );
}